<template>
  <div class="flex-col flex justify-between items-center h-full">
    <div>
      <div class="text-center flex items-center justify-center mt-5">
        <img src="/img/stars.png" alt="pr" class="w-36 rounded-xl" />
      </div>
      <div class="mt-5 text-center">
        <div
          class="inline-flex items-center justify-center gap-2 px-3 py-2 border text-center rounded-full"
          :class="[
            $theme.baseTextColor,
            $theme.inputBorderColor,
            $theme.cardBg,
          ]"
          >
          <CheckCircleIconOrange />
          <p>14-days Free Trial </p>
        </div>
      </div>
      <div class="text-3xl font-semibold text-center mt-5">
        {{ $t('try_for_free') }}
      </div>
      <div class="mt-3">
        <div class="text-center">
          {{ $t('activate_trial_period_n') }}
        </div>
        <div class="mt-2 text-center">
          {{ $t('activate_trial_period_n2') }}
        </div>
      </div>
    </div>
    <div class="mt-5 absolute w-full bottom-0 left-0 px-4 pb-5">
      <div class="mb-4 text-sm text-center opacity-50">{{ $t('link_card_note') }}</div>
      <router-link
          to="/link-card"
          class="flex w-full items-center justify-center rounded-xl px-3 py-3 font-semibold focus-visible:outline"
          :class="[
            $theme.bgBtn,
            $theme.whiteText,
          ]"
      >
        {{ $t('connect_card') }}
      </router-link>
      <button
        @click="onSkip"
        class="flex items-center justify-center font-semibold mx-auto mt-4"
        :class="[$theme.textOrange]"
      >
        {{ $t('skip') }}
      </button>
    </div>
  </div>
</template>

<script>
import CheckCircleIconOrange from "@/components/icons/CheckCircleIconOrange.vue";

export default {
  name: 'TrialStart',
  components: {
    CheckCircleIconOrange
  },
  methods: {
    onSkip() {
      this.$emit('skip');
    }
  },
  data() {
    return {
    }
  },

  mounted() {
  },
}
</script>
